import { API_PDC_URL_V2, APP_PDC_URL, REGISTRY_READ_URL } from "../../../config";
import { logout } from "./../auth";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { callWithRetry } from "../../services/callWithRetry";

export const studioConstants = {
  LOAD_STUDIO_START: "LOAD_STUDIO_START",
  LOAD_STUDIO_SUCCESS: "LOAD_STUDIO_SUCCESS",
  LOAD_STUDIO_ERROR: "LOAD_STUDIO_ERROR"
};

export function loadStudios() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: studioConstants.LOAD_STUDIO_START
      });

      const auth = getState().auth;

      let request = {
        method: "get",
        url: `${API_PDC_URL_V2}/anagrafica/studios`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      let request2 = {
        method: "get",
        url: `${REGISTRY_READ_URL}/items?fullText.classifiers=STUDIO&packageType=BASE&idList=0&pagination.pageNumber=0&pagination.itemsPerPage=10000&userId=${auth?.loginAuth?.id}`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      return callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          let finalResult = {...result, data: []};
          return callWithRetry(
            auth, request2, dispatch
          )
            .then((result2) => {
              result?.data?.map((res) => {
                let resFind = result2?.data?.items?.find(x => x?.item?.base?.uuid === res?.uuid);
                if (resFind /* && resFind?.item?.base?.id === "12547865514"*/){ // V: 12547865514 P: 11655900212 N: 30337830456 
                  finalResult?.data?.push({...res, additionalData: resFind.item.base });
                }
              });
              dispatch({
                type: studioConstants.LOAD_STUDIO_SUCCESS,
                payload: finalResult.data.filter((el) => {
                  return el.classifier === "STUDIO";
                })
              });
              resolve(finalResult);
            }).catch((response) => {
              if (response.message === "Network Error" || response.message === "Request failed with status code 403") {
                logout();
              }
              dispatch({
                type: studioConstants.LOAD_STUDIO_ERROR,
                payload: response.toString()
              });
              reject(JSON.parse(JSON.stringify(response)));
            });
        })
        .catch((response) => {
          if (response.message === "Network Error" || response.message === "Request failed with status code 403") {
            logout();
          }
          dispatch({
            type: studioConstants.LOAD_STUDIO_ERROR,
            payload: response.toString()
          });
          reject(JSON.parse(JSON.stringify(response)));
        });
    });
  };
}

export function loadStudiosCompany() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: studioConstants.LOAD_STUDIO_START
      });

      const auth = getState().auth;
      const idAzienda = getState().main.clientIdSelected;

      let request = {
        method: "get",
        url: `${APP_PDC_URL}/anagrafica/businessconsultants?companyId=${idAzienda}`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      return callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: studioConstants.LOAD_STUDIO_SUCCESS,
              payload: result.data
            });
            resolve(result);
          } else {
            dispatch({
              type: studioConstants.LOAD_STUDIO_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: studioConstants.LOAD_STUDIO_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}
